import { render, staticRenderFns } from "./unitDetail.vue?vue&type=template&id=7f4aade6&scoped=true"
import script from "./unitDetail.vue?vue&type=script&lang=js"
export * from "./unitDetail.vue?vue&type=script&lang=js"
import style0 from "./unitDetail.vue?vue&type=style&index=0&id=7f4aade6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4aade6",
  null
  
)

export default component.exports